/* Owner V1, 2026-09-25: manual carousel, stable grid stage, native scroll fallback. */
if (!customElements.get('rla-review-carousel')) {
  customElements.define('rla-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('.rrq-slide')];
      this.stage = this.querySelector('.rrq-stage');
      if (!this.slides.length || !this.stage) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots = [...this.querySelectorAll('[data-rrq-go]')];
      this.status = this.querySelector('.rrq-status');
      this.index = 0;
      this.show(0);
      this.classList.add('is-ready');
      this.stage.scrollLeft = 0;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rrq-step], [data-rrq-go]');
        if (!button) return;
        const next = button.hasAttribute('data-rrq-go')
          ? Number(button.dataset.rrqGo)
          : this.index + Number(button.dataset.rrqStep);
        this.show(next, true);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        event.preventDefault();
        let next = this.index + (event.key === 'ArrowRight' ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        this.show(next, true);
      }, options);

      // Capture only a committed swipe; contact must not steal chip clicks.
      this.stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.pointerType === 'mouse') return;
        this.touch = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, options);
      this.stage.addEventListener('pointermove', (event) => {
        if (!this.touch || event.pointerId !== this.touch.id) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        if (Math.abs(dy) > 16 && Math.abs(dy) > Math.abs(dx)) {
          this.touch = null;
        } else if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.stage.setPointerCapture(event.pointerId);
          this.touch = null;
          this.suppressClick = true;
          this.show(this.index + (dx < 0 ? 1 : -1), true);
        }
      }, options);
      const endTouch = () => {
        this.touch = null;
        clearTimeout(this.clickTimer);
        this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
      };
      this.stage.addEventListener('pointerup', endTouch, options);
      this.stage.addEventListener('pointercancel', endTouch, options);
      this.stage.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.rrq-slide');
        const next = this.slides.indexOf(slide);
        if (next >= 0) this.show(next);
      }, options);
    }

    show(index, announce = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      // Arrow keys on a chip must not strand focus inside a newly inert slide.
      if (this.slides.some((slide, i) => i !== this.index && slide.contains(document.activeElement))) {
        this.stage.focus({ preventScroll: true });
      }
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (announce && this.status) {
        const author = this.slides[this.index].querySelector('.rrq-author');
        this.status.textContent = `Quote ${this.index + 1} of ${this.slides.length}${author ? ` by ${author.textContent.trim()}` : ''}`;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.clickTimer);
      this.touch = null;
      this.suppressClick = false;
      this.classList.remove('is-ready');
      this.slides?.forEach((slide) => {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
      });
    }
  });
}
